<template>
  <div class="bg" :style="{ fontFamily: fonts,background: 'url(' + bgUrl + ') no-repeat center / 100% 100%' }">
    <home-header @changeFont="changeF"></home-header>
    <div class="bgbody">
      <div class="center">
        <div class="header">恭喜您，签到成功！</div>
        <div class="registerCon">
          <div class="radius">
            <img src="../assets/gou.png" alt="" />
            <div class="registerOk">签到成功</div>
          </div>
        </div>
        <div class="complete">
          <div class="comButton" @click="comHandle">
            <div class="comText">完成</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeHeader from "./header";
import { getMeetModel } from "@/utils/request";
export default {
  name: "register",
  components: {
    HomeHeader
  },
  data() {
    return {
      participants: [],
      fonts: "",
      timeClock: null,
      bgUrl:''
    };
  },
  created() {},
  mounted() {
    this.id = this.$route.query.id;
    this.meetingId = this.$route.query.meetingId;
    this.meetingName = this.$route.query.meetingName;
    this.bgUrl = localStorage.getItem('bgUrl')
    // this.timeClock = setInterval(() => {
    //   this.getMeetModels()
    // }, 2000);
    setTimeout(() => {
      this.comHandle();
    }, 10000);
  },
  beforeDestroy() {
    // if (this.timeClock) {
    //     clearInterval(this.timeClock)
    // }
  },
  methods: {
    // getMeetModels() {
    //   getMeetModel().then(res => {
    //     if (Number(res.code) === 0) {
    //       this.fonts = res.data.fontStyle;
    //     }
    //   });
    // },
    comHandle() {
      history.back();
    },
    changeF(font) {
      this.fonts = font;
    }
  }
};
</script>

<style lang="less" scoped>
.bg {
  width: 100%;
  height: 100%;
  color: #fff;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  // padding: 6% 1s0%;
  font-size: 36px;
  .bgbody {
    // padding: 5% 0;
    position: fixed;
    top: 15%;
    left: 0;
    right: 0;
    bottom: 0;
    .center {
      width: 70%;
      height: 80%;
      margin: 0 auto;
      background: rgba(255, 255, 255, 0.1);
      padding: 3% 8%;
      // font-weight: bold;
      .header {
        text-align: center;
        font-size: 40px;
        margin-bottom: 5%;
        letter-spacing: 3px;
      }
      .registerCon {
        display: flex;
        margin-bottom: 5%;
        .radius {
          margin: 0 auto;
          border-radius: 50%;
          text-align: center;
          background: url("../assets/touming.png") no-repeat;
          background-position: center;
          font-size: 36px;
          padding: 58px;
          .registerOk {
            background-image: linear-gradient(to bottom, #1cf7e9, #2ad8ff);
            -webkit-background-clip: text;
            color: transparent;
          }
        }
      }
    }
    .complete {
      width: 35%;
      height: 15%;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;
      .comButton {
        width: 234px;
        height: 80px;
        background: linear-gradient(0deg, #1bf7e9, #2ad7ff);
        border-radius: 4px;
        .comText {
          font-size: 30px;
          color: #ffffff;
          text-align: center;
          line-height: 80px;
        }
      }
    }
  }
}
@media screen and (max-width: 1440px) {
  .bg .center .registerCon {
    font-size: 20px;
    margin-bottom: 80px;
  }
  .bg .center .registerCon .registerRight .imgBox .imgtext {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/innerRegisterOk.vue